import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView } from 'medua-components';

/* eslint-disable */
@translate(['account'])
export default class AccountPrivacy extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:privacy.title') } />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/privacy/index.jsx